export const getIsProdEnv = () => {
  if (typeof window === 'undefined') return false
  return window.location.href.includes('woofz.com')
}
